import { SINGLE_PRODUCT_URL } from '@/utils/api';
import { http } from '@/plugins/http';
import { getApiResponse } from '@/utils/helper';

export const singleProduct = (id, vendor) => {
  return getApiResponse(() => http.get(`${SINGLE_PRODUCT_URL}/${vendor}/${id}`));
};
